// Verified patient quotes — published verbatim in the language they were shared in,
// with permission. Names withheld for privacy. Not edited or embellished.
export const TESTIMONIALS = [
    { id: 'listens', lang: 'en', quote: 'The doctor listens to you — and I mean she really listens. And in my case, she cried with me when I lost my mom.' },
    { id: 'extraction', lang: 'ms', quote: 'Cabut gigi langsung tak ada rasa, tau-tau gigi dah keluar. Terbaik!' },
    { id: 'friendly', lang: 'en', quote: 'The doctors are very friendly and sometimes funny too.' },
    { id: 'rahmah', lang: 'ms', quote: 'Klinik ni tak mahal. Memang harga rahmah dan doktornya boleh berlebih kurang. Baik klinik ni. Moga Allah murahkan rezeki doktor berdua.' },
    { id: 'mampu', lang: 'ms', quote: 'Braces mampu pakai dalam JB.' },
    { id: 'knows', lang: 'en', quote: 'This clinic knows what they are doing.' },
    { id: 'staff', lang: 'ms', quote: 'Staff klinik semua baik-baik dan comel-comel hehe.' },
];
